import { render, staticRenderFns } from "./BindCar.vue?vue&type=template&id=5bec15e9&scoped=true&"
import script from "./BindCar.vue?vue&type=script&lang=js&"
export * from "./BindCar.vue?vue&type=script&lang=js&"
import style0 from "./BindCar.vue?vue&type=style&index=0&id=5bec15e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec15e9",
  null
  
)

export default component.exports